// extracted by mini-css-extract-plugin
export default {"table":"ViewProducts_table__IKDDv","search":"ViewProducts_search__3fX1s","icons":"ViewProducts_icons__wSIYv"};